import { useState } from "react";
import { usePlay, Panel, Label } from "@/components/casual/usePlay";
import { BetControl } from "@/components/game/BetControl";
import { fmtAZN } from "@/lib/api";
import { sfx } from "@/lib/sound";
import { QUICK } from "./config";

const ChoiceBar = ({ cfg, choice, setChoice, busy }) => (
  <div><Label>{cfg.choiceLabel || "Seçim"}</Label>
    <div className={`grid gap-2 ${cfg.choices.length > 4 ? "grid-cols-5" : `grid-cols-${cfg.choices.length}`}`}>
      {cfg.choices.map((o) => (
        <button key={String(o.v)} disabled={busy} onClick={() => { sfx.click(); setChoice(o.v); }} data-testid={`quick-choice-${o.v}`}
          className={`rounded-xl py-2.5 px-1 font-display font-bold flex flex-col items-center transition-all ${choice === o.v ? `${o.bg || "bg-[#D4AF37] text-black"} ring-2 ring-[#FFD700]` : "bg-white/5 hover:bg-white/10"}`}>
          <span className="text-xs sm:text-sm leading-tight">{o.l}</span>{o.m && <span className="text-[10px] sm:text-xs opacity-80">{o.m}</span>}
        </button>
      ))}
    </div>
  </div>
);

export const QuickGame = ({ game, mode }) => {
  const cfg = QUICK[game.quick];
  const { busy, play, finish } = usePlay(mode);
  const [bet, setBet] = useState(1);
  const [choice, setChoice] = useState(cfg.choices ? cfg.choices[cfg.def || 0].v : null);
  const [res, setRes] = useState(null);
  const [phase, setPhase] = useState("idle");

  const go = async (c = choice) => {
    if (busy) return;
    setRes(null);
    setChoice(c);
    setPhase("anim");
    cfg.start?.();
    const d = await play(`/games/quick/${game.quick}`, { bet, choice: c });
    if (!d) { setPhase("idle"); return; }
    setRes(d);
    setTimeout(() => { setPhase("done"); finish(d); }, cfg.ms || 1500);
  };

  const done = phase === "done" && res;
  const msg = done ? (res.won ? `+${fmtAZN(res.win)}` : res.win > 0 ? `Qaytarıldı ${fmtAZN(res.win)}` : "Uduzdunuz") : "";
  const S = cfg.Stage;
  return (
    <div className="grid lg:grid-cols-[1fr_340px] gap-4 sm:gap-6" data-testid={`quick-${game.quick}-game`}>
      <div className="space-y-3 min-w-0">
        <S res={res} phase={phase} choice={choice} onPick={go} busy={busy} bet={bet} />
        <div className="h-9 flex items-center justify-center gap-3" data-testid="quick-result">
          {done && cfg.text && <span className="text-white/80 text-sm sm:text-base">{cfg.text(res)}</span>}
          {done && <span className={`font-display font-black text-xl sm:text-2xl ${res.won ? "text-emerald-300" : res.win > 0 ? "text-sky-300" : "text-red-300"}`} data-testid="quick-result-amount">{msg}</span>}
          {!done && phase === "idle" && <span className="text-white/50 text-sm">{cfg.hint}</span>}
        </div>
      </div>
      <Panel>
        <div><Label>Mərc</Label><BetControl value={bet} onChange={setBet} disabled={busy} testid="quick-bet" /></div>
        {cfg.choices && !cfg.pickInStage && <ChoiceBar cfg={cfg} choice={choice} setChoice={setChoice} busy={busy} />}
        {!cfg.pickInStage && (
          <button disabled={busy} onClick={() => go()} className="btn-gold w-full rounded-full py-4 font-display font-bold text-lg" data-testid="quick-play-btn">{cfg.action || "Oyna"} · {fmtAZN(bet)}</button>
        )}
        {cfg.pickInStage && <p className="text-sm text-[#FFD700] text-center" data-testid="quick-pick-hint">Oynamaq üçün yuxarıdan birini seçin</p>}
        <p className="text-xs text-zinc-500">{cfg.rules}</p>
      </Panel>
    </div>
  );
};
